import Vue from 'vue';
import Router from 'vue-router';
import Page from './views/Page.vue';
import NotFound from './views/NotFound.vue';

Vue.use(Router);

export default new Router({
  // mode: 'history',
  routes: [
    {
      path: '/:uid',
      name: 'page',
      component: Page,
    },
    {
      path: '/home',
      name: 'home',
      alias: '/'
    },
    {
      path: '/not-found',
      name: 'not-found',
      component: NotFound,
    },
    {
      path: '*',
      redirect: { name: 'not-found' },
    },
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
});
